import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions';

import {
  BaseQuery,
  CurrentSessionData,
  Response,
  TagTypes,
  TAG_TYPES
} from '../apiBase.types';
import { LoginRequest, ResetPasswordRequest, User } from '../../types/users';

const getAuthEndpoints = (
  builder: EndpointBuilder<BaseQuery, TagTypes, 'API'>
) => ({
  login: builder.mutation<Response<Pick<User, 'id'>>, LoginRequest>({
    query: (data: LoginRequest) => ({
      url: 'sessions/login',
      method: 'POST',
      body: data
    }),
    invalidatesTags: TAG_TYPES
  }),
  logout: builder.mutation<Response<Pick<User, 'id'>>, void>({
    query: () => ({
      url: 'sessions/current',
      method: 'DELETE'
    }),
    invalidatesTags: [TagTypes.CurrentSession, TagTypes.CurrentUser]
  }),
  currentSession: builder.query<Response<CurrentSessionData>, void>({
    query: () => ({
      url: 'sessions/current',
      method: 'GET'
    }),
    providesTags: [TagTypes.CurrentSession]
  }),
  resetPassword: builder.mutation<Response<void>, ResetPasswordRequest>({
    query: data => ({
      url: 'users/reset-password',
      method: 'POST',
      body: data
    })
  }),
  forgotPassword: builder.mutation<Response<void>, Pick<User, 'email'>>({
    query: data => ({
      url: 'users/forgot-password',
      method: 'POST',
      body: data
    })
  }),
  resendEmailConfirmation: builder.mutation<Response<void>, void>({
    query: () => ({
      url: `users/resend-email-confirmation`,
      method: 'POST'
    }),
    invalidatesTags: [TagTypes.CurrentUser]
  }),
  confirmUserEmailChange: builder.mutation<Response<void>, string>({
    query: token => ({
      url: `users/change-email-confirmation`,
      method: 'POST',
      body: {
        token
      }
    }),
    invalidatesTags: [TagTypes.CurrentUser]
  }),
  sendResetPasswordEmail: builder.mutation<Response<void>, string>({
    query: id => ({
      url: `users/forgot-password/${id}`,
      method: 'POST'
    })
  })
});

export default getAuthEndpoints;
